import { render } from "./ViewBook.vue?vue&type=template&id=9e1b8b3c"
import script from "./ViewBook.vue?vue&type=script&lang=js"
export * from "./ViewBook.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__